(() => {
  const root = document.getElementById('catpip-lp');
  if (!root) return;
  const config = JSON.parse(root.querySelector('[data-lp-product]').textContent);
  const cards = [...root.querySelectorAll('.plan')];
  const inputs = [...root.querySelectorAll('input[name="mode"]')];
  const note = root.querySelector('#mode-note');
  const subscribed = () => root.querySelector('input[name="mode"]:checked')?.value === 'subscribe';
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:config.currency}).format(value / 100);
  const allocation = variant => variant.plans.find(plan => plan.id === config.planId);
  const variants = cards.map(card => config.variants.find(v => v.rooms === Number(card.querySelector('[data-rooms]').dataset.rooms)));
  const canSubscribe = variants.every(v => v && allocation(v));
  root.querySelector(canSubscribe ? 'input[value="subscribe"]' : 'input[value="once"]').checked = true;
  if (!config.variants.length) {
    root.querySelector('.under-cta').textContent = 'This kit is not currently available in your shopping region.';
    note.setAttribute('role','status');
  }
  if (!canSubscribe) {
    root.querySelector('input[value="subscribe"]').closest('label').hidden = true;
    root.querySelectorAll('[data-subscribe],[data-lp-subscription-benefit],.round-badge,.offer-ticket,.announcement').forEach(el => el.hidden = true);
  }
  function update() {
    note.textContent = !config.variants.length ? 'This kit is not currently available in your shopping region. Contact us for availability.' : subscribed() ? 'Delivery every 8 weeks · 30% off · Skip or cancel anytime.' : 'A single purchase. No recurring delivery.';
    cards.forEach((card, index) => {
      const variant = variants[index];
      const button = card.querySelector('.plan-button');
      const plan = variant && allocation(variant);
      const available = variant?.available && (!subscribed() || plan);
      card.querySelector('.price').textContent = variant ? money(subscribed() && plan ? plan.price : variant.price) : 'Unavailable';
      card.querySelector('.plan-unit').textContent = subscribed() ? 'Total per delivery · ' + config.currency : 'Total · ' + config.currency;
      button.disabled = !available;
      button.querySelector('span').textContent = available ? (subscribed() ? 'GET MY 30% OFF' : 'START MY CAT’S CALMER ROUTINE') : variant ? 'SOLD OUT' : 'UNAVAILABLE IN YOUR REGION';
      button.querySelector('small').textContent = (index+1)+' '+(index ? 'rooms' : 'room')+' · '+(subscribed() ? 'Subscription every 8 weeks' : 'One-time purchase');
    });
  }
  inputs.forEach(input => input.addEventListener('change', update));
  root.querySelectorAll('[data-subscribe]').forEach(link => link.addEventListener('click', () => {
    if (!canSubscribe) return;
    root.querySelector('input[value="subscribe"]').checked = true;
    update();
  }));
  root.querySelectorAll('[data-lp-cart-link]').forEach(link => link.addEventListener('click', event => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.open) { event.preventDefault(); drawer.open(link); }
  }));
  let pending = false;
  cards.forEach((card,index) => card.querySelector('.plan-button').addEventListener('click', async event => {
    if (pending) return;
    const button = event.currentTarget;
    const variant = variants[index];
    if (!variant?.available) return;
    const plan = subscribed() ? allocation(variant) : null;
    if (subscribed() && !plan) return;
    const error = card.querySelector('[data-cart-error]');
    error.textContent = '';
    pending = true;
    cards.forEach(c => c.querySelector('.plan-button').disabled = true);
    button.setAttribute('aria-busy','true');
    button.querySelector('span').textContent = 'ADDING TO YOUR CART…';
    const drawer = document.querySelector('cart-drawer');
    const item = {id:variant.id,quantity:1};
    if (plan) item.selling_plan = plan.id;
    try {
      const payload = {items:[item]};
      if (drawer?.getSectionsToRender) {
        payload.sections = drawer.getSectionsToRender().map(section => section.id);
        payload.sections_url = location.pathname;
        drawer.setActiveElement(button);
      }
      const response = await fetch(config.root+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add this kit. Please try again.');
      if (drawer?.renderContents && data.sections && payload.sections.every(id => data.sections[id])) {
        try { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
        catch { location.assign(config.root+'cart'); return; }
      } else { location.assign(config.root+'cart'); return; }
      document.dispatchEvent(new CustomEvent('catpip:landing-cart-added',{detail:{variantId:variant.id,sellingPlanId:plan?.id || null}}));
    } catch (err) {
      error.textContent = err.message || 'Unable to add this kit. Please try again.';
    } finally {
      pending = false;
      button.removeAttribute('aria-busy');
      update();
    }
  }));
  let heroVisible = true, plansVisible = false;
  const sticky = root.querySelector('#sticky-offer');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if(entry.target.classList.contains('hero')) heroVisible=entry.isIntersecting; else plansVisible=entry.isIntersecting; });
    sticky.hidden = heroVisible || plansVisible || !canSubscribe;
  });
  observer.observe(root.querySelector('.hero'));
  observer.observe(root.querySelector('#plans'));
  update();
})();
